import { Modal, ModalBody, ModalHeader } from "@/components/bootstrap/TemporaryReactstrapCompatibilityLayer";
import { createPortal } from "react-dom";
import Button from "./layout/Button";
import useUpdateNotifier from "../customHooks/useUpdateNotifier";

const MajorUpdateModal = () => {
  const {
    isVisible,
    isOverlayVisible,
    handleCloseModal,
    handleOverlayClick,
    reload
  } = useUpdateNotifier();

  return createPortal(
    <>
      {isOverlayVisible && (
        <button
          onClick={handleOverlayClick}
          className="fullscreen-overlay-button"
        />
      )}
      <Modal isOpen={isVisible} toggle={handleCloseModal} className="update-view-modal" backdrop ={true} >
        <ModalHeader toggle={handleCloseModal}>NEW VERSION AVAILABLE</ModalHeader>
        <ModalBody>
          <p>A new version of the application is available. Please reload.</p>
          <div className="update-modal-actions">
            <Button label="Reload" className="update-modal-reload-button" clickHandler={reload} />
          </div>
        </ModalBody>
      </Modal>
    </>,
    document.body
  );
};

export default MajorUpdateModal;
